import React, { useEffect, useState } from "react";
import { Page } from "@/components/Shell";
import { API, LOGO_REVELATEUR } from "@/lib/brand";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const MESSAGES = [
  "Votre lecture stratégique est en cours de structuration.",
  "Les différentes dimensions de votre organisation sont actuellement mises en relation.",
  "Les forces et les tensions observées sont examinées.",
  "Vos Révélations Stratégiques™ sont en préparation.",
  "Votre priorité principale est en cours d'identification.",
  "Le rapport final est en cours de rédaction.",
];

export default function Revealing() {
  const { token } = useParams();
  const nav = useNavigate();
  const [idx, setIdx] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    const t = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 2600);
    (async () => {
      try { await axios.post(`${API}/reports/${token}/generate`); if (alive) nav(`/rapport/${token}`); }
      catch { if (alive) setError("Une erreur est survenue pendant la lecture. Veuillez réessayer."); }
    })();
    return () => { alive = false; clearInterval(t); };
  }, [token, nav]);

  return (
    <Page tone="dark">
      <div className="min-h-screen bg-grad-mix flex flex-col items-center justify-center relative overflow-hidden" data-testid="revealing-page">
        <div className="watermark"><img src={LOGO_REVELATEUR} alt="" /></div>
        <div className="relative z-10 text-center px-6 md:px-10 max-w-2xl">
          <div className="overline overline-ivory mb-8">Lecture en cours</div>
          <h1 className="font-display text-[38px] md:text-[54px] leading-tight text-ivory">Vos réponses prennent forme.</h1>
          <div className="architect-line my-10 max-w-xs mx-auto" style={{ background: "rgba(196,147,97,0.6)" }} />
          <div className="h-14 flex items-center justify-center">
            {!error ? (
              <div key={idx} className="fade-up text-bronze-light font-display italic text-[22px] md:text-[24px]" data-testid="revealing-message">
                {MESSAGES[idx]}
              </div>
            ) : <div className="text-[color:var(--stone)] text-sm">{error}</div>}
          </div>
          <div className="mt-16 text-[11px] tracking-[0.32em] uppercase text-ivory-2">Observer · Interpréter · Révéler · Orienter</div>
        </div>
      </div>
    </Page>
  );
}
